$(document).ready(function () {

  $('.slick-slider').slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    dotsClass: 'custom-dots',
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  /* Responsive menu color */
  $('body').on('click', '.navbar-toggler', function () {
    $('.header-menu').toggleClass('open')
  });

  /* Search modal */
  $('body').on('click', '.search-icon', function () {
    $('.modal-search').addClass('show').find('input:first-child').focus();
  });

  $('body').on('click', '.search-close-btn, .result-item', function () {
    $('.modal-search').removeClass('show');
  });

  $('body').on('click', '#load-more-articles', function (e) {
    e.preventDefault();

    let page = parseInt($(this).data('page')) + 1;
    let button = $(this);
    let container = button.closest('.onpage-article-list').find('.article-list');

    $.get(`?ajax=load-more&pg=${page}`, function (result) {
      container.append($(result));
      button.data('page', page);

      if (page >= parseInt(container.data('max-pages'))) {
        button.remove();
      }
    });
  });

  let keyupTimeout;
  $('body').on('keyup', 'input#search-input', function () {
    clearTimeout(keyupTimeout);

    let input = $(this);
    let form = $(this).closest('form');

    if (input.val().length >= 3) {
      keyupTimeout = setTimeout(function () {
        $.ajax({
          type: 'GET',
          url: form.attr('action') + '?whisperer=1&q=' + input.val(),
          success: function (response) {
            $('.modal-search .search-results-wrapper').show().html(response);
          },
          error: function () {
            $('#newsletter-subscribe-result-error').modal('show');
          }
        });
      }, 400);
    }
  });

  /* Filter modal */
  $('body').on('click', '.filter-button', function () {
    $('.modal-filter').addClass('show');
  });

  $('body').on('click', '.filter-close-btn', function () {
    $('.modal-filter').removeClass('show');
  });

  $('body').on('click', '.main .title .expander', function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).parent().parent().toggleClass('open');
  })

  $('body').on('click', '.main .title', function (e) {
    e.stopPropagation();
    e.preventDefault();

    $(this).find('label input').prop('checked', !$(this).find('label input').prop('checked'));
    $(this).find('label').toggleClass('active');

    if ($(this).find('label').hasClass('active')) {
      $(this).parent().find('ul .territory-item label').addClass('active');
    } else {
      $(this).parent().find('ul .territory-item label input').prop('checked', false);
      $(this).parent().find('ul .territory-item label').removeClass('active');
    }
  });

  var filteredItems = {
    territory: [],
    themes: []
  };

  $('body').on('click', '.theme-item label, .territory-item label', function (e) {
    e.stopPropagation();
    e.preventDefault();

    let filterName = $(this).text();

    $(this).find('input').prop('checked', !$(this).find('input').prop('checked'));
    $(this).toggleClass('active');

    if ($(this).parent().hasClass('theme-item')) {
      if (filteredItems.themes.includes(filterName)) {
        filteredItems.themes.splice(filteredItems.themes.indexOf(filterName), 1)
      } else {
        filteredItems.themes.push(filterName);
      }
    } else {
      if (filteredItems.territory.includes(filterName)) {
        filteredItems.territory.splice(filteredItems.territory.indexOf(filterName), 1)
      } else {
        filteredItems.territory.push(filterName);
      }
    }

    let totalItems = $(this).closest('ul').find('label.active').length;
    let checkedItems = $(this).closest('ul').find('label').length;

    if (totalItems === checkedItems) {
      $(this).closest('.main').find('ul .territory-item label input').prop('checked', false);
      $(this).closest('.main').find('.title label input').prop('checked', true);
      $(this).closest('.main').find('.title label').addClass('active');
    } else {
      $(this).closest('.main').find('.title label input').prop('checked', false);
      $(this).closest('.main').find('.title label').removeClass('active');
    }
  });

  /* Paginator */
  let maxPage = parseInt($('.article-filter .paginator .max-page').text());
  let keyupTimeout2;

  $('body').on('keyup', '.paginator .counter', function () {
    clearTimeout(keyupTimeout2);

    let input = $(this);

    keyupTimeout2 = setTimeout(function () {
      let page = parseFloat(input.val());

      page = Math.min(page, maxPage);
      page = Math.max(page, 1);

      window.location.href = input.data('base-uri') + page;
    }, 400);
  });

  $('body').on('click', '#next-articles', function (e) {
    e.preventDefault();

    let url = $(this).attr('href');

    $.ajax({
      type: 'GET',
      url: url,
      success: function (response) {
        let responseHtml = $(response);

        $('body').find('.article-list').append(responseHtml.find('.article-list').html());
        $('body').find('.article-filter .paginator').html(responseHtml.find('.article-filter .paginator').html());
        $('body').find('.article-list-options').html(responseHtml.find('.article-list-options').html());

        window.history.pushState(null, null, url);
      },
    });
  });


  $('body').on('submit', 'form#newsletter-subscribe', function (e) {
    e.preventDefault();

    let form = $(this);

    $.ajax({
      type: 'POST',
      url: form.attr('action'),
      data: form.serialize(),
      success: function (data) {
        $('#newsletter-subscribe-result-' + data.status).modal('show');
        form[0].reset();
      },
      error: function () {
        $('#newsletter-subscribe-result-error').modal('show');
      }
    });
  });

  $('body').on('click', '.hp-news a', function(e) {
    if(typeof gtag !== 'undefined') {
      e.preventDefault();
      var link = $(this).prop('href');

      gtag('event', 'HP_carousel', {
        'event_callback': function () {
          window.location.href = link;
        }
      });
    }

    window.location.href = link;
  });
});

window.dataLayer = window.dataLayer || [];

function gtag(){
  window.dataLayer.push(arguments);
}

//window.addEventListener('load', buildWidget);
